import axios from "axios";

axios.defaults.withCredentials = true;

const TYPE_PIECE_ENDPOINT = "/api/types-pieces";

export default {
  async getTypesPieces() {
    const response = await axios.get(TYPE_PIECE_ENDPOINT);
    return response.data;
  },
  async getBOTypePiece(idTypePiece) {
    const response = await axios.get(TYPE_PIECE_ENDPOINT + "/" + idTypePiece);
    return response.data;
  },
  async addTypePiece(typePiece) {
    const response = await axios.post(TYPE_PIECE_ENDPOINT, typePiece);
    return response.data;
  },
  async updateTypePiece(id, typePiece) {
    const response = await axios.put(TYPE_PIECE_ENDPOINT + "/" + id, typePiece);
    return response.data;
  },
  async deleteTypePiece(idTypePiece) {
    const response = await axios.delete(
      TYPE_PIECE_ENDPOINT + "/" + idTypePiece
    );
    return response.data;
  },
};
